import { EventObject, ExtractEvent } from "xstate"
import * as O from "fp-ts/Option"
import { Option } from "fp-ts/Option"
import * as F from "fp-ts/function"
import * as S from "fp-ts/string"
import * as ROA from "fp-ts/ReadonlyArray"

export function assertEvent<TEventType extends TEvent["type"], TEvent extends EventObject = EventObject>(
    e: TEvent,
    ...types: TEventType[]
): asserts e is ExtractEvent<TEvent, TEventType> {
    if (!isOneOfExpectedEvent(types)(e))
        throw new Error(`Invariant violation: Expected event "${types.join(" or ")}" but instead got "${e.type}"`)
}

export const maybeEvent = <TEventType extends TEvent["type"], TEvent extends EventObject = EventObject>(
    e: TEvent,
    ...types: TEventType[]
): Option<ExtractEvent<TEvent, TEventType>> => F.pipe(e, O.fromPredicate(isOneOfExpectedEvent(types)))

const isOneOfExpectedEvent =
    <TEventType extends TEvent["type"], TEvent extends EventObject = EventObject>(types: TEventType[]) =>
    (e: TEvent): e is ExtractEvent<TEvent, TEventType> =>
        F.pipe(types, ROA.elem(S.Eq)(e.type))
